import client from '../httpClient';

const directUpdateApi = (directId, params) => {
  return client.put(`/directs/${String(directId)}`, JSON.stringify(params));
};

export default directUpdateApi;
